import { useEffect, useState } from 'react';
import { FeedbackCaptureSheet } from './FeedbackCaptureSheetChunk';

/** The window event a desktop entry raises to open the feedback sheet (F-0361, AC-FB19, AC-FB20). */
export const OPEN_FEEDBACK_EVENT = 'featit:open-feedback';

/** Opens the feedback sheet from anywhere: the sidebar's footer, the command palette. */
export function openFeedbackSheet(): void {
  window.dispatchEvent(new Event(OPEN_FEEDBACK_EVENT));
}

/**
 * F-0361 (G2, I-0463): the one place a desktop entry's sheet is drawn, mounted once at the router
 * root beside `ShellRuntime`. The phone's drawer row and shake reach the sheet through the shell's
 * own `openFeedback` event, which `ShellRuntime` already hosts; this host answers the web's own
 * entries, so the two never both open on one trigger. In a browser there is no `screenshot`
 * capability, so the sheet opens on the gallery's picker (decision 2's browser path).
 */
export function FeedbackSheetHost() {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onOpen = () => setOpen(true);
    window.addEventListener(OPEN_FEEDBACK_EVENT, onOpen);
    return () => window.removeEventListener(OPEN_FEEDBACK_EVENT, onOpen);
  }, []);
  return open ? <FeedbackCaptureSheet onClose={() => setOpen(false)} /> : null;
}
